export default "__VITE_ASSET__BmlKeP4K__"